import { render, staticRenderFns } from "./OrderFoodManagement.vue?vue&type=template&id=abd2d344&scoped=true"
import script from "./OrderFoodManagement.vue?vue&type=script&lang=js"
export * from "./OrderFoodManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodManagement.vue?vue&type=style&index=0&id=abd2d344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd2d344",
  null
  
)

export default component.exports